(function () {
  if (window.__pgSelect) return;
  window.__pgSelect = true;

  var CHEV = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  var uid = 0;

  function enhance(sel) {
    if (sel.dataset.pgDone === '1') return;
    sel.dataset.pgDone = '1';
    uid += 1;
    var id = 'pgsel-' + uid;
    var wrap = document.createElement('div');
    wrap.className = 'pgsel';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('pgsel__native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pgsel__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    var lbl = sel.getAttribute('aria-label');
    var forLabel = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
    if (forLabel) { forLabel.setAttribute('for', id + '-btn'); btn.id = id + '-btn'; }
    else if (lbl) btn.setAttribute('aria-label', lbl);
    btn.innerHTML = '<span class="pgsel__val"></span><span class="pgsel__chev">' + CHEV + '</span>';

    var list = document.createElement('ul');
    list.className = 'pgsel__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;

    var opts = Array.prototype.slice.call(sel.options);
    opts.forEach(function (o, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.dataset.i = i;
      li.innerHTML = '<span>' + o.textContent + '</span><i class="pgsel__ck">' + CHECK + '</i>';
      list.appendChild(li);
    });
    wrap.appendChild(btn);
    wrap.appendChild(list);

    var items = list.children;
    var hot = -1;

    function sync() {
      var cur = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;
      btn.querySelector('.pgsel__val').textContent = opts[cur] ? opts[cur].textContent : '';
      wrap.classList.toggle('is-placeholder', !!opts[cur] && opts[cur].value === '');
      for (var i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-selected', i === cur ? 'true' : 'false');
        items[i].classList.toggle('is-sel', i === cur);
      }
    }
    function setHot(i) {
      if (hot > -1 && items[hot]) items[hot].classList.remove('is-hot');
      hot = i;
      if (items[hot]) { items[hot].classList.add('is-hot'); items[hot].scrollIntoView({ block: 'nearest' }); }
    }
    function open() {
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      setHot(sel.selectedIndex < 0 ? 0 : sel.selectedIndex);
      var r = list.getBoundingClientRect();
      wrap.classList.toggle('is-up', r.bottom > window.innerHeight - 12 && btn.getBoundingClientRect().top > r.height + 20);
    }
    function close() {
      list.hidden = true;
      wrap.classList.remove('is-open', 'is-up');
      btn.setAttribute('aria-expanded', 'false');
    }
    function choose(i) {
      if (!opts[i]) return;
      sel.selectedIndex = i;
      sync();
      close();
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      btn.focus();
    }

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    btn.addEventListener('keydown', function (e) {
      var k = e.key;
      if (list.hidden) {
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ') { e.preventDefault(); open(); }
        return;
      }
      if (k === 'ArrowDown') { e.preventDefault(); setHot(Math.min(items.length - 1, hot + 1)); }
      else if (k === 'ArrowUp') { e.preventDefault(); setHot(Math.max(0, hot - 1)); }
      else if (k === 'Home') { e.preventDefault(); setHot(0); }
      else if (k === 'End') { e.preventDefault(); setHot(items.length - 1); }
      else if (k === 'Enter' || k === ' ') { e.preventDefault(); choose(hot); }
      else if (k === 'Escape') { e.preventDefault(); close(); }
      else if (k === 'Tab') { close(); }
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (li) choose(parseInt(li.dataset.i, 10));
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('li');
      if (li) setHot(parseInt(li.dataset.i, 10));
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    sel.addEventListener('change', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('select[data-pg-select]').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
